import { createSelector } from '@reduxjs/toolkit';
import { settingsApi } from './settings-api';

const selectLanguagesResult = settingsApi.endpoints.getLanguages.select();

export const selectLanguages = createSelector(
  [selectLanguagesResult],
  (result) => result.data ?? [],
);
